import { Check } from 'lucide-react';
import { cn } from '@/lib/utils';

export interface WizardStep {
  id: number;
  label: string;
  description: string;
}

export const WIZARD_STEPS: WizardStep[] = [
  { id: 1, label: 'Company Setup', description: 'Add your companies' },
  { id: 2, label: 'User Access', description: 'Assign company access' },
  { id: 3, label: 'General Settings', description: 'Configure metrics & customer settings' },
  { id: 4, label: 'Templates', description: 'Document templates' },
  { id: 5, label: 'Collection Strategies', description: 'Automate collections' },
  { id: 6, label: 'Dispute Types', description: 'Define dispute categories' },
];

interface OnboardingStepIndicatorProps {
  currentStep: number; // 0 = welcome, 1-6 = steps, 7 = complete
}

export function OnboardingStepIndicator({ currentStep }: OnboardingStepIndicatorProps) {
  return (
    <div className="flex flex-col gap-1">
      {WIZARD_STEPS.map((step) => {
        const isCompleted = currentStep > step.id;
        const isCurrent = currentStep === step.id;
        const isRemaining = currentStep < step.id;

        return (
          <div key={step.id} className="flex items-start gap-3 px-4 py-2.5 rounded-lg">
            {/* Step circle */}
            <div
              className={cn(
                'flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-xs font-semibold transition-colors',
                isCompleted && 'bg-primary text-primary-foreground',
                isCurrent && 'bg-primary/20 text-primary ring-2 ring-primary',
                isRemaining && 'bg-muted text-muted-foreground',
              )}
            >
              {isCompleted ? <Check className="h-3.5 w-3.5" /> : step.id}
            </div>

            {/* Labels */}
            <div className="flex flex-col min-w-0">
              <span
                className={cn(
                  'text-sm font-medium leading-tight',
                  isCurrent && 'text-foreground',
                  isCompleted && 'text-foreground',
                  isRemaining && 'text-muted-foreground',
                )}
              >
                {step.label}
              </span>
              <span className="text-xs text-muted-foreground truncate">{step.description}</span>
            </div>
          </div>
        );
      })}
    </div>
  );
}
